import { ColourVariant } from "@shared/ui.design-system";
import { Typography } from "@shared/ui.primitives";
import React from "react";

import { basePromoBanner } from "./PromoBanner.css";

export type Props = {
  text: string;
  colour: "accent.dark";
};

export const getPromoBannerTextColour = (
  colour: "accent.dark"
): ColourVariant => {
  switch (colour) {
    case "accent.dark":
      return "secondary-light";
    default:
      return "secondary-light";
  }
};

export const PromoBanner: React.FC<Props> = ({ text, colour }) => {
  return (
    <div data-testid="ribbon-wrapper" className={basePromoBanner({ colour })}>
      <div>
        <Typography
          colour={getPromoBannerTextColour(colour)}
          variant="smallprint-sm-bold"
        >
          {text}
        </Typography>
      </div>
    </div>
  );
};
